import { VEHICLE_COLOR_RGB } from 'src/app/modules/shared/models/vehicle/vehicle-icons-enum';

const DARK_VEHICLE_COLORS = new Set<string>([VEHICLE_COLOR_RGB.Gray]);

// Reuse a single canvas+context across all calls to avoid exceeding the browser's
// canvas-context limit (~300), which would cause "Out of memory at imageData creation".
const BADGE_CANVAS_SIZE = 96; // pixelRatio 2 @ 48 logical px — matches VehicleIcon dimensions
let _badgeCanvas: HTMLCanvasElement | null = null;
let _badgeCtx: CanvasRenderingContext2D | null = null;

function getBadgeContext(): CanvasRenderingContext2D {
    if (!_badgeCanvas) {
        _badgeCanvas = document.createElement('canvas');
        _badgeCanvas.width = BADGE_CANVAS_SIZE;
        _badgeCanvas.height = BADGE_CANVAS_SIZE;
        _badgeCtx = _badgeCanvas.getContext('2d', { willReadFrequently: true });
    }
    return _badgeCtx;
}

export function createVehicleTextBadge(
    title: string,
    rgbColor: string,
): { width: number; height: number; data: Uint8ClampedArray } {
    const canvasSize = BADGE_CANVAS_SIZE;
    const logicalSize = canvasSize / 2;
    const ctx = getBadgeContext();

    // Reset transform before clearing so clearRect covers the full canvas.
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.clearRect(0, 0, canvasSize, canvasSize);
    ctx.setTransform(2, 0, 0, 2, 0, 0); // scale(2,2) for pixelRatio

    const cx = logicalSize / 2;  // 24
    const cy = logicalSize / 2;  // 24

    // Opaque circle — same color as the vehicle arrow, covers lower-priority badges when stacked
    ctx.beginPath();
    ctx.arc(cx, cy, 13, 0, Math.PI * 2);
    ctx.fillStyle = rgbColor;
    ctx.fill();

    ctx.font = 'bold 11px "Open Sans", sans-serif';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillStyle = DARK_VEHICLE_COLORS.has(rgbColor) ? '#fff' : '#000';
    ctx.fillText(title, cx, cy);

    // Reset transform before reading pixels so coordinates match canvas pixels 1:1.
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    const imageData = ctx.getImageData(0, 0, canvasSize, canvasSize);
    return { width: canvasSize, height: canvasSize, data: new Uint8ClampedArray(imageData.data) };
}
